import { auth } from '@/services';
import { PromotionPolicy } from '@/policies';

(function (angular) {
    'use strict';

    angular.module('app')
        .service('Promotions', promotions);

    promotions.$inject = [
        'modalService'
    ];

    function promotions(
        modalService
    ) {
        /**
         * Opens a modal allowing a user to manage a promotion item
         * @var {int} id - (Optional) ID of promotion to edit
         * @return {{ result: Promise<any> }} - modalService containing result.then
         */
        function managePromotion(id?: null | number): { result: Promise<any> } {
            const result = new Promise((resolve, reject) => {
                if (!id && !PromotionPolicy.canCreate(auth.user())) {
                    return reject('You do not have permission to create a new promotion.');
                }

                modalService.open({
                    templateUrl: 'modals/manage-promotion.html',
                    controller: 'managePromotionController',
                    controllerAs: 'vm',
                    windowClass: 'manage-promotion',
                    resolve: {
                        promotionId: () => id || null,
                    },
                })
                    .result
                    .then(resolve)
                    .catch(reject);
            });

            return { result };
        }

        return {
            managePromotion,
        };
    }

}(angular));
